export const FEEDBACK_SOURCES = {
  CONTACT: "website-contact",
  BOOK_DEMO: "website-book-demo",
} as const;

export type FeedbackSource =
  (typeof FEEDBACK_SOURCES)[keyof typeof FEEDBACK_SOURCES];

export const REGION_OPTIONS = ["APAC", "EMEA", "Americas"] as const;

export const CONTACT_HELP_OPTIONS = [
  "Request a Demo",
  "Get Onboarding Help",
  "Ask About AI Features",
  "Email Us Directly",
  "Feature Improvement",
  "New Features",
  "Bug or Issues",
  "Plan & Billing",
  "Support",
  "Other",
] as const;

export const BOOK_DEMO_HELP_OPTIONS = [
  "Sales enquiry",
  "Request a Demo",
  "Product walkthrough",
  "Enterprise plan pricing",
  "Other",
] as const;

export type FeedbackFormFields = {
  first_name: string;
  last_name: string;
  email: string;
  company_name: string;
  company_url?: string;
  region: string;
  help_purpose: string;
  subject?: string;
  message: string;
  source: FeedbackSource;
  files?: File[];
};

/** Builds multipart FormData matching /api/v1/cms-feedback-form/ */
export function buildFeedbackFormData(fields: FeedbackFormFields): FormData {
  const formData = new FormData();

  formData.append("source", fields.source);
  formData.append("first_name", fields.first_name.trim());
  formData.append("last_name", fields.last_name.trim());
  formData.append("email", fields.email.trim());
  formData.append("company_name", fields.company_name.trim());

  if (fields.company_url?.trim()) {
    formData.append("company_url", fields.company_url.trim());
  }

  formData.append("region", fields.region);
  formData.append("help_purpose", fields.help_purpose);

  if (fields.subject?.trim()) {
    formData.append("subject", fields.subject.trim());
  }

  formData.append("message", fields.message.trim());

  fields.files?.forEach((file, index) => {
    if (file) {
      formData.append(`file${index}`, file);
    }
  });

  return formData;
}
